function SuccessIcon() {
  return (
    <svg
      width="80"
      height="81"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.3337 17.767L35.3003 55.8337L21.167 41.7003L25.867 37.0003L35.3003 46.4337L68.6337 13.1003L73.3337 17.767ZM65.967 34.567C66.4003 36.467 66.667 38.467 66.667 40.5003C66.667 55.2337 54.7337 67.167 40.0003 67.167C25.267 67.167 13.3337 55.2337 13.3337 40.5003C13.3337 25.767 25.267 13.8337 40.0003 13.8337C45.267 13.8337 50.1337 15.367 54.267 18.0003L59.067 13.2003C53.667 9.40033 47.1003 7.16699 40.0003 7.16699C21.6003 7.16699 6.66699 22.1003 6.66699 40.5003C6.66699 58.9003 21.6003 73.8337 40.0003 73.8337C58.4003 73.8337 73.3337 58.9003 73.3337 40.5003C73.3337 36.5337 72.6003 32.7337 71.3337 29.2003L65.967 34.567Z"
        fill="#10B981"
      />
    </svg>
  );
}

export default SuccessIcon;
